import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const OverviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/overview" */
    'routes/Extensions/Reperks/OverviewRoute'
  )
));

const ConnectionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/connections" */
    'routes/Extensions/Reperks/ConnectionsRoute'
  )
));

const UpdateSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/update-settings" */
    'routes/Extensions/Reperks/UpdateSettingsRoute'
  )
));

const UpdateWidgetRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/update-widget" */
    'routes/Extensions/Reperks/UpdateWidgetRoute'
  )
));

const MembersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/members" */
    'routes/Extensions/Reperks/MembersRoute'
  )
));

const ActivitiesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/activities" */
    'routes/Extensions/Reperks/ActivitiesRoute'
  )
));

const MemberProfileRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/member-profile" */
    'routes/Extensions/Reperks/MemberProfileRoute'
  )
));

const EarningPointsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/earning-points" */
    'routes/Extensions/Reperks/EarningPointsRoute'
  )
));

const UpdateActivityRuleRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/update-activity-rule" */
    'routes/Extensions/Reperks/UpdateActivityRuleRoute'
  )
));

const RewardsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/rewards" */
    'routes/Extensions/Reperks/RewardsRoute'
  )
));

const UpdateRewardRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/update-reward" */
    'routes/Extensions/Reperks/UpdateRewardRoute'
  )
));

const RewardCouponsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/reward-coupons" */
    'routes/Extensions/Reperks/RewardCouponsRoute'
  )
));

const AnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/analytics" */
    'routes/Extensions/Reperks/AnalyticsRoute'
  )
));

const UpdateEmailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/update-emails" */
    'routes/Extensions/Reperks/UpdateEmailsRoute'
  )
));

const EmailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/emails" */
    'routes/Extensions/Reperks/EmailsRoute'
  )
));

const EmailRecipientsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/email-recipients" */
    'routes/Extensions/Reperks/EmailRecipientsRoute'
  )
));

const EmailAnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/email-analytics" */
    'routes/Extensions/Reperks/EmailAnalyticsRoute'
  )
));

const EmailConversionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reperks/email-conversions" */
    'routes/Extensions/Reperks/EmailConversionsRoute'
  )
));



const getReperksRoutes = () => {
  return [
    {path: paths.getPathReperksOverview(), component: OverviewRoute},
    {path: paths.getPathReperksLoyaltySetup(), render: (props) => <Redirect to={paths.getPathReperksOverview()}  {...props} />},
    {path: paths.getPathReperksConnections(), component: ConnectionsRoute},
    {path: paths.getPathEditReperksSettings(), component: UpdateSettingsRoute},
    {path: paths.getPathEditReperksWidget(), component: UpdateWidgetRoute},

    {path: paths.getPathReperksMembers(), component: MembersRoute},
    {path: paths.getPathReperksActivities(), component: ActivitiesRoute},
    {path: paths.getPathReperksMemberProfile(":memberId"), component: MemberProfileRoute},
    {path: paths.getPathReperksAnalytics(), component: AnalyticsRoute},

    {path: paths.getPathReperksEarningPoints(), component: EarningPointsRoute},
    {path: paths.getPathAddReperksActivityRule(), component: UpdateActivityRuleRoute},
    {path: paths.getPathEditReperksActivityRule(":ruleId"), component: UpdateActivityRuleRoute},
    {path: paths.getPathReplicateReperksActivityRule(":ruleId"), render: (props) => <UpdateActivityRuleRoute {...props} isReplicate={true} />},

    {path: paths.getPathReperksRewards(), component: RewardsRoute},
    {path: paths.getPathAddReperksReward(), component: UpdateRewardRoute},
    {path: paths.getPathEditReperksReward(":rewardId"), component: UpdateRewardRoute},
    {path: paths.getPathReplicateReperksReward(":rewardId"), render: (props) => <UpdateRewardRoute {...props} isReplicate={true} />},
    {path: paths.getPathReperksRewardCoupons(":rewardId"), component: RewardCouponsRoute},

    {path: paths.getPathEditReperksEmails(), component: UpdateEmailsRoute},
    {path: paths.getPathReperksEmails(), component: EmailsRoute},
    {path: paths.getPathReperksEmailRecipients(":emailId"), component: EmailRecipientsRoute},
    {path: paths.getPathReperksEmailAnalytics(":emailId"), component: EmailAnalyticsRoute},
    {path: paths.getPathReperksEmailConversions(":emailId"), component: EmailConversionsRoute},
  ]
}


export { getReperksRoutes };
